<template>
  <main class="home">
    <section class="home__section home__section_promo">
      <h1 class="home__title">
        Multi-Markets Sales Management System</h1>
      <ul class="home__list">
        <li class="home__item">Clear</li>
        <li class="home__item">Smart</li>
        <li class="home__item">Adjustable</li>
      </ul>
    </section>

    <section class="home__section home__section_login">
      <img alt="Multi-Markets Sales Management System logo"
           width="139"
           height="72"
           src="./assets/Logo.svg"
      class="home__logo logo">
      <p class="home__form-description">Sign in to Manage Markets System</p>
      <Login class="home__form home__form_login"/>

      <p class="home__form-description home__form-description_register">Don't have an account yet?</p>
      <p class="home__form-description home__form-description_register">Get early access</p>
      <Register class="home__form home__form_register"/>
    </section>
  </main>
</template>

<script>
import Login from '@/components/form/Login'
import Register from '@/components/form/Register'

export default {
  name: 'app',
  components: {
    Login,
    Register
  }
}
</script>

<style lang="scss">
  body {
    padding: 0;
    margin: 0;
    font-family: 'Roboto', 'Arial', sans-serif;
  }

  .home {
    display: flex;
    height: 100vh;
    justify-content: space-between;

    &__section {
      box-sizing: border-box;
      display: flex;
      flex-direction: column;

      &_promo {
        flex-grow: 5.9;
        padding: 271px 90px 0 90px;
        order: 1;
        background: {
          image: url('/img/home-background.jpg');
        };
      }

      &_login {
        align-items: center;
        flex-grow: 1;
        padding: 161px 100px 50px;
      }
   }

    &__title {
      width: 338px;
      padding: 0;
      margin: 24px 0 0;
      font-size: 36px;
      font-weight: 300;
      line-height: 42px;
      color: #ffffff;
      order: 1;
    }

    &__list {
      padding: 0;
      margin: 0;
      list-style: none;
    }

    &__item {
      font-size: 80px;
      line-height: 94px;
      font-weight: 700;
      color: #ffffff;
    }

    &__logo {
      display: block;
      margin-bottom: 51px;
      margin-left: 8px;
    }

    &__form-description {
      width: 390px;
      margin: 0px -5px 0 0;
      padding: 0;
      font-size: 25px;
      font-weight: 400;
      line-height: 29px;
      text-align: center;

      &_register {
        font-size: 20px;
        line-height: 29px;

        &:first-child {
          letter-spacing: 0.2px;
          margin-left: 4px;
        }
      }
    }

    &__form {
      width: 390px;
      margin: 0 auto;

      &_login {
        margin-top: 51px;
        margin-bottom: 81px;
      }

      &_register {
        margin-top: 26px;
      }
    }
  }

  .fade-enter-active, .fade-leave-active {
    transition: opacity .5s;
  }
  .fade-enter, .fade-leave-to {
    opacity: 0;
  }
</style>
